import { defineStore } from "pinia";
import useToggle from "@shared/hooks/toggle";
import { ref } from "vue";

const useGoods = (_goods = []) => {
  const goods = ref([_goods]);

  const setGoods = (val = []) => {
    goods.value = val;
  };

  return [goods, setGoods];
};

const useModel = (_model = {}) => {
  const model = ref({});

  const setModel = (val = {}) => {
    model.value = val;
  };

  return [model, setModel];
};

const useDiscountDetailsStore = defineStore("discount-details", () => {
  /** 控制折扣详情弹框显示 */
  const [visible, toggle] = useToggle(false);
  const [goods, setGoods] = useGoods([{ id: 1 }]);
  const [model, setModel] = useModel({});

  return {
    visible,
    toggle,
    goods,
    setGoods,
    model,
    setModel,
  };
});

export default useDiscountDetailsStore;
